import { ref } from 'vue';
import { EtaCondition } from '@nova/core';

export default function useEta() {
  const etaCondition = ref('');

  const getEtaConditionMeta = etaConditionVal => {
    const meta = {
      color: '',
      classes: ''
    };

    switch (etaConditionVal) {
      case EtaCondition.Early:
        meta.color = 'blue';
        meta.classes = 'lighten-5 black--text';
        break;
      case EtaCondition.Late:
        meta.color = 'error';
        meta.classes = 'white--text';
        break;
      default:
        break;
    }

    return meta;
  };

  return {
    etaCondition,
    getEtaConditionMeta
  };
}
